import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { BsFillCircleFill } from '@react-icons/all-files/bs/BsFillCircleFill';
import { Placement, Tooltip } from './Tooltip';

export interface ISocketIconProps {
    onClick?(): void;
    readonly connected?: boolean;
    readonly showText?: boolean;
    readonly className?: string;
    readonly id?: string;
    readonly placement?: Placement;
    readonly connectedText?: string;
    readonly disconnectedText?: string;
}

@observer
export class SocketIcon extends React.Component<ISocketIconProps> {
    public render() {
        return (
            <div className={this.props.className + ' d-inline-block '}>
                <a id={this.props.id} onClick={this.props.onClick}>
                    <Tooltip message={this.tooltipMessage} placement={this.props.placement}>
                        {this.props.connected && (
                            <span className="connected-websocket d-inline-flex">
                                <BsFillCircleFill className=" socket-bounce" />
                                <BsFillCircleFill className=" socket-bounce" />
                                <BsFillCircleFill className=" socket-bounce" />
                            </span>
                        )}

                        {!this.props.connected && (
                            <span className="disconnected-websocket d-inline-flex">
                                <BsFillCircleFill />
                                <BsFillCircleFill />
                                <BsFillCircleFill />
                            </span>
                        )}
                        {this.props.showText && this.props.connected && (
                            <span>{this.props.connectedText ?? 'Online'}</span>
                        )}
                        {this.props.showText && !this.props.connected && (
                            <span>{this.props.disconnectedText ?? 'Error, Offline'}</span>
                        )}
                    </Tooltip>
                </a>
            </div>
        );
    }

    @computed
    private get tooltipMessage() {
        const connectedText = this.props.connectedText ?? 'Online';
        const disconnectedText = this.props.disconnectedText ?? 'Error, Offline';

        if (this.props.connected) return connectedText;

        if (!this.props.connected) return disconnectedText;

        return '';
    }
}
